import SortingPresenter from "../presenter/sorting.js";
import ViewTypesPresenter from "../presenter/view-types.js";

import ActionsView from "../view/actions.js";

export default class Actions {
  constructor(element, changeFilter, browserNavigation) {
    this._actionsView = new ActionsView(element);
    this._changeFilter = changeFilter;
    this._browserNavigation = browserNavigation;

    this._sortingPresenter = null;
    this._viewTypesPresenter = null;
  }

  init() {
    this._sortingPresenter = new SortingPresenter(
        this._actionsView.getSortingButtons(),
        this._actionsView.getSortingForm(),
        this._changeFilter,
        this._browserNavigation
    );
    this._sortingPresenter.init();

    this._viewTypesPresenter = new ViewTypesPresenter(
        this._actionsView.getViewTypesElement(),
        this._changeFilter,
        this._browserNavigation
    );
    this._viewTypesPresenter.init();
  }
}
